import { useState } from 'react';

/**
 * The tile for an exercise (public/art/exercises/<id>.jpg, made on the AUX
 * board). Nothing is drawn when the file is not there yet, so the road reads
 * the same with or without art.
 */
export function ExerciseArt({ id, className, style }: { id: string; className?: string; style?: React.CSSProperties }) {
  const [gone, setGone] = useState(false);
  if (gone) return null;
  return <img className={className} style={style} src={`/art/exercises/${id}.jpg`} alt="" onError={() => setGone(true)} />;
}
